import {
	GET_RECOMMENDED,
	GET_RECOMMENDED_START,
	HANDLE_RECOMMENDED_ERROR,
	RESET_RECOMMENDED,
} from '../constants';

const initState = {
	programs: null,
};
const recommended = (state = initState, action) => {
	switch (action.type) {
		case RESET_RECOMMENDED:
			return initState;
		case GET_RECOMMENDED_START:
			return {
				...state,
				[action.pageNumber]: {
					...state[action.pageNumber],
					data: null,
					isLoading: true,
				},
			};
		case GET_RECOMMENDED:
			return {
				...state,
				programs: action.pageNumber === 1 ? [...action.programs] : state.programs,
				[action.pageNumber]: {
					...state[action.pageNumber],
					data: action.programs,
					isLoading: false,
					pageSize: action.paging.pageSize,
					totalPages: action.paging.totalPages,
					totalCount: action.paging.totalCount,
					hasNextPage: action.paging.hasNextPage,
				},
			};
		case HANDLE_RECOMMENDED_ERROR:
			return {
				...state,
				programs: {
					errorCode: action.errorCode,
				},
			};
		default:
			return state;
	}
};

export default recommended;
